import template from './asset-alerts.component.html';
import * as AssetDetailsActions from '../../../../state/asset-details/asset-details.actions';
class AssetAlertsController {
  constructor($ngRedux) {
    'ngInject';
    this.store = $ngRedux;
    this.onClearingAlert = this.onClearingAlert.bind(this);
  }
  $onInit() {
    this.unsubscribe = this.store.connect(() => ({}), {...AssetDetailsActions})(this);
  }
  $onChanges() {}
  $onDestroy() {
    this.unsubscribe();
  }

  onClearingAlert() {
    this.getAssetData(this.asset.id);
  }
}

export default {
  template,
  controller: AssetAlertsController,
  //not useing vm as when using ui-route it is conflicting with parent vm
  //https://github.com/johnpapa/angular-styleguide/issues/577#issue-115275989
  controllerAs: 'alertVm',
  bindings: {
    loading: '<',
    refreshing: '<',
    asset: '<'
  }
};
